import React from "react"
import { Link, graphql } from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx"
import TalkyardCommentsIframe from "@debiki/gatsby-plugin-talkyard"

import Bio from "../components/bio"
import Layout from "../components/layout"
import SEO from "../components/seo"
// import { rhythm, scale } from "../utils/typography"

class BlogPostTemplate extends React.Component<{
  data: any
  pageContext: any
  location: any
}> {
  render() {
    const post = this.props.data.mdx
    const siteTitle = this.props.data.site.siteMetadata.title
    const { previous, next } = this.props.pageContext

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title={post.frontmatter.title}
          description={post.frontmatter.description || post.excerpt}
          // image={post.frontmatter.featuredimage?.childImageSharp?.original?.src}
        />
        <article>
          <header className="mt-8">
            <span className="text-sm text-gray-500">
              {post.fields.slug.split("/")[1]}
            </span>
            <h1 className="text-3xl md:text-5xl font-black mb-0 font-header">
              {post.frontmatter.title}
            </h1>
            <p className="text-sm leading-loose mb-8 ">
              {post.frontmatter.date}
              {post.frontmatter.lastModified &&
                post.frontmatter.date !== post.frontmatter.lastModified && (
                  <> (last updated {post.frontmatter.lastModified})</>
                )}{" "}
              - {post.fields.readingTime.text}
            </p>
          </header>
          <div className="markdown prose-sm">
            <p
              className="font-bold"
              dangerouslySetInnerHTML={{
                __html: (post.frontmatter.description || post.excerpt)
                  .split("\n")
                  .join("<br/>"),
              }}
            />
            <MDXRenderer>{post.body}</MDXRenderer>
          </div>
          <hr className="h-px mt-24 mb-8" />
          <footer>
            <Bio />
          </footer>
        </article>

        <nav className="mt-16 mb-8">
          <ul
            className="flex flex-wrap justify-between mb-8"
            // style={{
            //   display: `flex`,
            //   flexWrap: `wrap`,
            //   justifyContent: `space-between`,
            //   listStyle: `none`,
            //   padding: 0,
            // }}
          >
            <li className="w-full text-center">
              {previous && (
                <Link
                  className="text-blue-600"
                  to={previous.fields.slug}
                  rel="prev"
                >
                  ← {previous.frontmatter.title}
                </Link>
              )}
            </li>
            <li className="w-full text-center">
              {next && (
                <Link
                  className="text-blue-600"
                  to={next.fields.slug}
                  rel="next"
                >
                  {next.frontmatter.title} →
                </Link>
              )}
            </li>
          </ul>
        </nav>

        {post.discussionId && (
          <div className="mb-48">
            <hr className="h-px mt-24 mb-8" />
            <h2>Comments</h2>
            <TalkyardCommentsIframe discussionId={post.discussionId} />
          </div>
        )}
      </Layout>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    mdx(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      body
      fields {
        slug
        readingTime {
          text
          time
          words
        }
        discussionId
      }
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        lastModified(formatString: "MMMM DD, YYYY")
        description
      }
    }
  }
`
/*

        featuredimage {
          childImageSharp {
            original {
              src
            }
          }
        }

 */
